import { render, staticRenderFns } from "./SafetyToolbar.vue?vue&type=template&id=6e720147"
import script from "./SafetyToolbar.vue?vue&type=script&lang=js"
export * from "./SafetyToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports